import React from "react";
import styles from "./Phantom.module.css";

import page01Bg from "../../../assets/brochure/phantom/Phantom_01_bg.webp";

import asset1 from "../../../assets/brochure/phantom/Asset 1.webp";
import asset2 from "../../../assets/brochure/phantom/Asset 2.webp";
import asset3 from "../../../assets/brochure/phantom/Asset 3.webp";

import page02Bg from "../../../assets/brochure/phantom/Group 2.webp";
import asset4 from "../../../assets/brochure/phantom/Asset 4.webp";
import asset5 from "../../../assets/brochure/phantom/Asset 5.webp";
import asset6 from "../../../assets/brochure/phantom/Asset 6.webp";

import asset7 from "../../../assets/brochure/phantom/Asset 7.webp";
import asset8 from "../../../assets/brochure/phantom/Asset 8.webp";
import asset9 from "../../../assets/brochure/phantom/Asset 9.webp";
import asset10 from "../../../assets/brochure/phantom/Asset 10.webp";
import asset11 from "../../../assets/brochure/phantom/Asset 11.webp";
import asset12 from "../../../assets/brochure/phantom/Asset 12.webp";
import asset13 from "../../../assets/brochure/phantom/Asset 13.webp";
import asset14 from "../../../assets/brochure/phantom/Asset 14.webp";

import page04Bg from "../../../assets/brochure/phantom/Phantom Rovo_05_EN.webp";

import page05Bg from "../../../assets/brochure/phantom/Phantom Rovo_06_EN.webp";

import asset15 from "../../../assets/brochure/phantom/Asset 15.webp";
import asset16 from "../../../assets/brochure/phantom/Asset 16.webp";
import asset17 from "../../../assets/brochure/phantom/Asset 17.webp";
import asset18 from "../../../assets/brochure/phantom/Asset 18.webp";
import asset19 from "../../../assets/brochure/phantom/Asset 19.webp";
import asset20 from "../../../assets/brochure/phantom/Asset 20.webp";

import page07Bg from "../../../assets/brochure/phantom/Phantom_07.jpg";

const Phantom = () => {
  return (
    <div className={styles.phantomBrochure}>

      

      <section className={styles.page01}>

        <img
          src={page01Bg}
          alt="Phantom Rovo"
          className={styles.page01Bg}
        />

        

        <div className={styles.page01Intro}>
          <p>The first steps have been taken.</p>
          <p>The start of the healthcare robot,</p>
          <strong>Phantom Rovo</strong>
        </div>


        

        <div
          className={`${styles.page01Feature} ${styles.page01Feature01}`}
        >
          <div className={styles.page01FeatureText}>
            <h3>XD PRO Module</h3>

            <p>
              Finger Moving Technology that
              <br />
              moves in 1.25mm increments for
              <br />
              precise and delicate massage.
            </p>
          </div>

          <img
            src={asset1}
            alt="XD PRO Module"
            className={styles.page01FeatureIcon}
          />
        </div>


        

        <div
          className={`${styles.page01Feature} ${styles.page01Feature02}`}
        >
          <div className={styles.page01FeatureText}>
            <h3>
              Leg Massage Unit
              <br />
              Independent Movement
            </h3>

            <p>
              The left and right leg massage units
              <br />
              operate separately from each other
              <br />
              to allow for new movements and stretching.
            </p>
          </div>

          <img
            src={asset2}
            alt="Leg Massage Unit Independent Movement"
            className={styles.page01FeatureIcon}
          />
        </div>


        

        <div
          className={`${styles.page01Feature} ${styles.page01Feature03}`}
        >
          <div className={styles.page01FeatureText}>
            <h3>Safety Breakdown</h3>

            <p>
              Industry-leading 15 sensors,
              <br />
              low-temperature burn protection,
              <br />
              remote control lock, and power
              <br />
              failure protection buttons.
            </p>
          </div>

          <img
            src={asset3}
            alt="Safety Breakdown"
            className={styles.page01FeatureIcon}
          />
        </div>


        

        <div className={styles.page01Concept}>

          <p className={styles.page01ConceptLabel}>
            Design concept
          </p>

          <h2>
            Hypercar Dynamics meets Healthcare Robotics
          </h2>

          <div className={styles.page01ConceptSpacer} />

          <p className={styles.page01ConceptDescription}>
            The future direction of Bodyfriend development is towards
            <br />
            the healthcare robot and this principle has been implemented
            to create a massage chair far beyond existing standard chairs.
            <br />
            Feel the sensibility of wearing a robot suit.
          </p>

        </div>

      </section>


      

      <section className={styles.page02}>

        

        <div className={styles.page02Top}>

          

          <img
            src={page02Bg}
            alt=""
            className={styles.page02TopBg}
          />


          

          <div className={styles.page02TopText}>

            <div className={styles.page02ShortLine} />

            <h2>XD PRO Module</h2>

            <p className={styles.page02TopLead}>
              A high-performance sensor is applied to the XD module that can
              <br />
              adjust the protruding range of the massage ball in increments
              <br />
              of 1.25mm to provide a delicate and precise customized massage.
            </p>


            <div className={styles.page02Originals}>

              <h3>
                BODYFRIEND Originals Finger Moving Technology
              </h3>

              <p>
                Bodyfriend’s Moving Technology is a key advancement that
                precisely controls the
                <br />
                movement of the massage ball in increments of 1.25mm, as if
                you were
                <br />
                being massaged carefully by human fingers.
              </p>

            </div>

          </div>

        </div>


        

        <div className={styles.page02Bottom}>

          <div className={styles.page02BottomHeader}>

            <div className={styles.page02ShortLineLight} />

            <h2>
              Enhanced Thermal Functionality
            </h2>

            <p>
              Feel a warm and cozy massage with heated massage balls
              <br />
              in the back, calves, and soles. Can be toggled by region.
            </p>

          </div>


          <div className={styles.page02ThermalGrid}>

            

            <div className={styles.page02ThermalItem}>

              <img
                src={asset4}
                alt="Massage Ball"
              />

              <h3>Massage Ball</h3>

              <p>
                The upper two massage balls are heated and can provide a
                warm massage as if done by human hands.
              </p>

            </div>


            

            <div className={styles.page02ThermalItem}>

              <img
                src={asset5}
                alt="Back, Calf Seat"
              />

              <h3>Back, Calf Seat</h3>

              <p>
                The back and calf seats have thermal function to
                allow for heated massage.
              </p>

            </div>


            

            <div className={styles.page02ThermalItem}>

              <img
                src={asset6}
                alt="Foot Sole Roller"
              />

              <h3>Foot Sole Roller</h3>

              <p>
                Heating function was also applied to the sole rollers to
                provide a warm acupressure massage for the feet.
              </p>

            </div>

          </div>

        </div>

      </section>

      

<section className={styles.page03}>

  

  <div className={styles.page03Header}>

    <div className={styles.page03ShortLine} />

    <h2>
      Our Largest Ever! 87 Air Pockets
    </h2>

    <p>
      The airbag expands to every corner of the body and
      <br />
      provides refreshing compression as if by human hands.
    </p>

  </div>


  

  <div className={styles.page03Grid}>

    

    <div className={styles.page03Item}>
      <img src={asset7} alt="Shoulder Massage" />

      <h3>Shoulder Massage</h3>

      <p>
        Relieves stiff muscles and fatigue in the shoulders.
        By holding the upper body in place, this allows the
        massage balls to penetrate and stimulate the muscles deeper.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset8} alt="Back Waist Massage" />

      <h3>Back/Waist Massage</h3>

      <p>
        Four double airbags apply pressure and support
        the back and waist.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset9} alt="Hand Arm Massage" />

      <h3>Hand, Arm Massage</h3>

      <p>
        The 3-stage airbag encompasses the hands and arms
        simultaneously, while the built-in magnetic acupressure
        pad provides a refreshing massage.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset10} alt="Pelvic thigh massage" />

      <h3>Pelvic/thigh massage</h3>

      <p>
        The airbags on the left and right sides of the pelvis inflate
        to provide a balanced massage and hold the lower body
        in place during stretching.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset11} alt="Perineum" />

      <h3>Perineum</h3>

      <p>
        The independently developed perineal airbag provides
        acupressure to the buttocks and surrounding muscles.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset12} alt="Calf Massage" />

      <h3>Calf Massage</h3>

      <p>
        Airbags provide thorough massage to both sides
        of the calf and foot.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset13} alt="Foot Instep" />

      <h3>Foot Instep</h3>

      <p>
        The airbag presses down on the instep so that the roller
        can provide deep and invigorating acupressure.
      </p>
    </div>


    

    <div className={styles.page03Item}>
      <img src={asset14} alt="Heel" />

      <h3>Heel</h3>

      <p>
        An airbag in the shape of tongs compresses
        and massages the heel firmly.
      </p>
    </div>

  </div>

</section>


<section className={styles.page04}>

  
  <img
    src={page04Bg}
    alt="Faster Body Shape Recognition"
    className={styles.page04Bg}
  />

  
  <div className={styles.page04Content}>

    <div className={styles.page04ShortLine} />

    <h2>
      Faster Body Shape Recognition
    </h2>

    <p className={styles.page04Description}>
      The body recognition process, which used to take about 60 seconds,
      <br />
      has been reduced to about 15 seconds.
    </p>

    <p className={styles.page04Note}>
      *May differ depending on the user's posture or body type.
    </p>

  </div>

</section>



<section className={styles.page05}>

  <img
    src={page05Bg}
    alt="A Safer Massage Chair"
    className={styles.page05Bg}
  />

  <div className={styles.page05Header}>
    <h2>A Safer Massage Chair</h2>

    <p>
      Diversified ‘movement’ and upgraded ‘functions’
      <br />
      make for an enhanced ‘safety device’.
    </p>
  </div>

</section>



<section className={styles.page06}>

  <h2 className={styles.page06Title}>
    Convenience Features
  </h2>

  <div className={styles.page06TitleSpace}></div>

  <div className={styles.page06Grid}>

    
    <div className={styles.page06Item}>
      <img src={asset15} alt="Remote Control Holder" />

      <h3>
        <span>01</span> Remote Control Holder
      </h3>

      <p>
        Neat and convenient remote-control holder.
      </p>
    </div>


    
    <div className={styles.page06Item}>
      <img src={asset16} alt="Zero Gravity Angle" />

      <h3>
        <span>02</span> Zero Gravity Angle
      </h3>

      <p>
        Relax the whole body with gravity applied to the body to
        <br />
        maximize sleep and massage effects.
      </p>
    </div>


    
    <div className={styles.page06Item}>
      <img src={asset17} alt="Automatic Slide Angle Adjustment" />

      <h3>
        <span>03</span> Automatic Slide Angle Adjustment
      </h3>

      <p>
        Designed to minimize the space required for angle
        <br />
        adjustment, allowing for efficient usage of space.
      </p>
    </div>


    
    <div className={styles.page06Item}>
      <img src={asset18} alt="Quick ON OFF By Region" />

      <h3>
        <span>04</span> Quick ON/OFF By Region
      </h3>

      <p>
        Easy to adjust airbags and rollers during massage by region.
      </p>
    </div>


    
    <div className={styles.page06Item}>
      <img src={asset19} alt="Favorites Mode" />

      <h3>
        <span>05</span> Favorites Mode
      </h3>

      <p>
        Conveniently store up to eight frequently used
        <br />
        modes and settings.
      </p>
    </div>


    
    <div className={styles.page06Item}>
      <img src={asset20} alt="Automatic Bluetooth Connection" />

      <h3>
        <span>06</span> Automatic Bluetooth Connection
      </h3>

      <p>
        After initial setup, Bluetooth will automatically connect when
        <br />
        the remote control is powered on.
      </p>
    </div>

  </div>

</section>



<section className={styles.page07}>
  <img
    src={page07Bg}
    alt="Phantom Rovo"
    className={styles.page07Image}
  />
</section>
    </div>
  );
};

export default Phantom;